define('../app/fukit/behavior/invoke.model.method.on.event.behavior',['require','exports','module','underscore','backbone','marionette','bluebird'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      Backbone = require('backbone'),
      Mn       = require('marionette'),
      Promise  = require('bluebird');

  var InvokeModelMethodOnEventBehavior = Mn.Behavior.extend({
    defaults: {
      // model method name that will be invoked
      method: null,

      // listen to this view event
      eventName: 'press',

      // when specified, this model will be used to trigger event on
      model: null,

      // same as model but kept for legacy support
      targetModel: null,

      // when true, use first argument passed to event to resolve target model
      resolveTargetModelFromEventArguments: false,

      // function to execute when succesfully invoked method
      onMethodSuccess: null,

      // event to trigger when successfully invoked method
      onMethodSuccessEvent: null,

      // function to execute when failed to invoke method
      onMethodError: null,

      // event to trigger when failed to invoke method
      onMethodErrorEvent: null,
      showLoading: false,
    },

    initialize: function() {
      this.listenTo(this.view, this.getOption('eventName'), this.onEvent);
    },

    onEvent: function() {
      this.eventArgs = _.toArray(arguments);
      this.invokeModelMethod();
    },

    //legacy support
    getTargetModel: function() {
      return this.getResource();
    },

    getResource: function() {
      if (this.getOption('model')) {
        return this.getOption('model');
      } else if (this.getOption('targetModel')) {
        return this.getOption('targetModel');
      } else if (this.getOption('resolveTargetModelFromEventArguments')) {
        return _.find(this.eventArgs, function(arg) {
          return arg instanceof Backbone.Model;
        });
      } else {
        return this.view.model;
      }
    },

    invokeModelMethod: function() {
      //prettier-ignore
      var self                 = this,
          onMethodSuccess      = this.getOption('onMethodSuccess'),
          onMethodSuccessEvent = this.getOption('onMethodSuccessEvent'),
          onMethodError        = this.getOption('onMethodError'),
          onMethodErrorEvent   = this.getOption('onMethodErrorEvent'),
          method               = Mn._getValue(this.getOption('method'), this),
          showLoading          = this.getOption('showLoading'),
          model                = this.getTargetModel(),
          args                 = Mn._getValue(this.getOption('methodArguments'), this, [model]) || [];

      if (method && model && model[method]) {
        if (showLoading) {
          this.view.loading = true;
        }
        return Promise.try(function() {
          return model[method].apply(model, args);
        })
          .then(function(resp) {
            if (onMethodSuccess) {
              onMethodSuccess.call(self, model, resp);
            }
            if (onMethodSuccessEvent) {
              self.view.trigger(onMethodSuccessEvent, model, resp);
            }
            return true;
          })
          .catch(function(e) {
            if (onMethodError) {
              onMethodError.call(self, model, e);
            }
            if (onMethodErrorEvent) {
              self.view.trigger(onMethodErrorEvent, model, e);
            }
            throw e;
          })
          .finally(function() {
            if (showLoading) {
              self.view.loading = false;
            }
          });
      }
    },
  });

  module.exports = InvokeModelMethodOnEventBehavior;
});

